import moment from "moment";

export const formatDate = date => {
  if (!date) return "Not selected";
  return moment(date).format("MM/DD/YYYY hh:mm A");
};

export const formatDatePretty = date => {
  if (!date) return "Not selected";
  return moment(date).format("MMM DD YYYY hh:mm A");
};

export const formatDateOnlyPretty = date => {
  if (!date) return "Not selected";
  return moment(date).format("MMMM DD, YYYY");
};

export const formatDateOnly = (date, format) => {
  if (!date) return "Not selected";
  return moment(date, format ? format : null).format("MM/DD/YYYY");
};

export const formatTimeOnly = (time, format) => {
  if (!time) return "Not selected";
  return moment(time, format ? format : null).format("hh:mm A");
};

export const formatDateOnlyMysql = (date, format) => {
  return moment(date, format ? format : null).format("YYYY-MM-DD");
};

export const formatTimeOnlyMysql = (date, format, outputFormat) => {
  return moment(date, format ? format : null).format(
    outputFormat ? outputFormat : "HH:mm:ss"
  );
};

export const formatDateTimeMysql = (date, format) => {
  return moment(date, format ? format : null).format("YYYY-MM-DD HH:mm:ss");
};

export const formatRelativeDatePretty = (today, date) => {
  if (!today || !date) {
    return "Today";
  }

  const momentToday = moment(today);
  const momentDate = moment(date);

  if (momentToday.date() == momentDate.date()) {
    return "Today";
  }

  if (momentToday.add(-1, "day").date() == momentDate.date()) {
    return "Yesterday";
  }

  return momentDate.format("LL");
};

export const getDateFromFormat = (date, format) => {
  return moment(date, format).toDate();
};

export const formatDateTimeSql = dateTime => {
  return moment(dateTime).format("YYYY-MM-DDTHH:mm:ss");
};

export const formatDateISO = dateTime => {
  return moment(dateTime).toISOString();
};

export const formatStartDateSql = date => {
  return date ? formatDateTimeSql(date + " 00:00:00") : null;
};

export const formatEndDateSql = date => {
  return date ? formatDateTimeSql(date + " 23:59:59") : null;
};

export const getAge = birthDate => {
  return moment().diff(birthDate, "years");
};

export const enumerateDaysBetweenDates = (startDate, endDate) => {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");

  while (currDate.diff(lastDate) <= 0) {
    dates.push(currDate.clone().toDate());
    currDate.add(1, "days");
  }

  return dates;
};

export const checkDateFormat = (date, format) => {
  return moment(date, format, true).isValid();
};

export const formatSecondsToMinutes = time => {
  var minutes = Math.floor(time / 60);
  var seconds = time - minutes * 60;
  var hours = Math.floor(time / 3600);
  time = time - hours * 3600;

  return str_pad_left(minutes, "0", 2) + ":" + str_pad_left(seconds, "0", 2);
};

export const getWeekDay = date => {
  if (!date) return "";
  return moment(date).format("e");
};

export const parseNearestTime = time => {
  const parts = time.split(":");
  let hours = parseInt(parts[0]);
  let minutes = parseInt(parts[1]);
  let m = 0;
  if (minutes > 45) m = 45;
  else if (minutes > 30) m = 30;
  else if (minutes > 15) m = 15;
  let h = minutes > 52 ? (hours === 23 ? 0 : ++hours) : hours;
  return str_pad_left(h, "0", 2) + ":" + str_pad_left(m, "0", 2);
};

export const calculateDuration = (fromValue, toValue) => {
  const duration = moment.duration(moment(toValue).diff(moment(fromValue)));
  const hours = duration.asHours();
  return hours.toFixed(2);
};

export const formatTimeAgo = (date, currentTime) => {
  if (!date) return "Not selected";
  return moment(date).from(currentTime);
};

export const formatDateTimeDuration = (startDate, endDate, allDay = false) => {
  if (!startDate) {
    return null;
  }

  if (allDay) {
    return `${formatDateOnly(startDate)} All day`;
  }
  if (!endDate) {
    return null;
  }

  const duration = moment.duration(moment(endDate).diff(moment(startDate)));
  const durationAsMinutes = duration.asMinutes();

  const endTime = formatTimeOnly(
    moment(startDate).add(durationAsMinutes, "minutes")
  );

  return `${formatDate(startDate)} - ${endTime} (${durationAsMinutes}min)`;
};

function str_pad_left(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}
